import request from '@/utils/request'

export async function getVehicle(data) {
  return request({
    url: '/device/record/car/page',
    method: 'post',
    data,
  })
}

export async function getPerson(data) {
  return request({
    url: '/device/record/person/page',
    method: 'post',
    data,
  })
}

// 查询车辆过闸记录对应的车辆预约记录
export async function queryCarApplicationRecord(data) {
  return request({
    url: '/device/record/car/queryCarApplicationRecord',
    method: 'get',
    params: data,
  })
}

// 查询人员过闸记录对应的人员预约记录
export async function queryPersonApplicationRecord(data) {
  return request({
    url: '/device/record/person/queryPersonApplicationRecord',
    method: 'get',
    params: data,
  })
}